import { formatApiDateRangeDisplay } from '#/utils/date';

/**
 * FMS 列表區間篩選 ↔ listQuery.filters。
 * - 總額：`totalAmountMin`／`totalAmountMax`（API `total_amount_min`／`total_amount_max`，含端點）
 * - 憑證日期：`voucherDateFrom`／`voucherDateTo`（API `voucher_date_from`／`voucher_date_to`）
 * 後端每個 key 只能出現一次，故一律單值字串。
 */
export function applyTotalAmountRange(setFilter, { min, max } = {}) {
  setFilter('totalAmountMin', min == null ? '' : String(min).trim());
  setFilter('totalAmountMax', max == null ? '' : String(max).trim());
}

export const TOTAL_AMOUNT_FILTER_STATUS_FIELDS = [
  { key: 'totalAmountMin', label: '最小總額' },
  { key: 'totalAmountMax', label: '最大總額' },
];

export function readVoucherDateRangeFilter(filters = {}) {
  const from = filters.voucherDateFrom;
  const to = filters.voucherDateTo;
  if (!from && !to) {
    return undefined;
  }
  return { from: from ?? '', to: to ?? from ?? '' };
}

export function applyVoucherDateRange(setFilter, range) {
  const from = range?.from || '';
  const to = range?.to || range?.from || '';
  setFilter('voucherDateFrom', from);
  setFilter('voucherDateTo', from || to ? to : '');
}

export function resolveVoucherDateFilterChipDisplay(_values, ctx = {}) {
  const display = formatApiDateRangeDisplay({
    from: ctx.filters?.voucherDateFrom,
    to: ctx.filters?.voucherDateTo,
  });
  return display ? [display] : [];
}

/** 狀態 chip 移除憑證日期（key＝voucherDateFrom）時連同迄日一起清。 */
export function createFmsFilterChipChange(setFilter) {
  return (key, value) => {
    setFilter(key, value);
    if (key === 'voucherDateFrom' && !value) {
      setFilter('voucherDateTo', '');
    }
  };
}
